export default __webpack_public_path__ + "4c7db38e74a60b57f3174588bd1b5c52.png";